const isValidComponentSize = (val) => ["", "large", "default", "small"].includes(val);
const isValidDatePickType = (val) => [
  "year",
  "month",
  "date",
  "dates",
  "week",
  "datetime",
  "datetimerange",
  "daterange",
  "monthrange"
].includes(val);

export { isValidComponentSize, isValidDatePickType };
//# sourceMappingURL=validators.mjs.map
